import {
    Questionnaire
} from "../actions/repo/questionnaire"


import {
    QuestionnaireSection
} from "../actions/repo/questionnaire-section"

import {
    QuestionnaireQuestion
} from "../actions/repo/questionnaire-question";

import {
    Workflow
} from "../actions/repo/workflow"

import {
    DataProvider
} from "../actions/repo/data-provider"

import {
    Content
} from "../actions/repo/content"


export const repo = {
    questionnaire: Questionnaire,
    questionnaire_section: QuestionnaireSection,
    questionnaire_question: QuestionnaireQuestion,
    workflow: Workflow,
    data_provider: DataProvider,
    content: Content
}